import { CategoryAxis } from '@amcharts/amcharts5/xy';
import { Constant } from '@/modules/core/legacy/charts/am5/charts.constants';

export function useCategoryAxis(context) {
  const { root, config } = context();
  function createCategoryAxis(props, renderer) {
    const { isSparkLine } = config.value;
    const axis = CategoryAxis.new(root.value, {
      categoryField: props.category,
      renderer,
    });
    axis.data.setAll(config.value.data);
    if (isSparkLine) {
      renderer.grid.template.set(Constant.VISIBLE, false);
      renderer.labels.template.set(Constant.VISIBLE, false);
      axis.cursorTooltipEnabled = false;
    }
    return axis;
  }

  return { createCategoryAxis };
}
